import { importService as baseImportService } from './importService.js';
import { finalizeImportedTripLinkRegistry } from './importLinkRegistryFinalize.js';

let registered = false;

/**
 * Wraps legacy importService.createTripWithData to finalize link registry after entity import.
 * Safe to call multiple times.
 */
export function registerImportLinkRegistryWrapper() {
  if (registered) {
    return baseImportService;
  }

  const originalCreateTripWithData = baseImportService.createTripWithData.bind(baseImportService);

  baseImportService.createTripWithData = async function createTripWithDataWithLinkRegistry(data, userId) {
    const result = await originalCreateTripWithData(data, userId);

    if (result?.tripId) {
      await finalizeImportedTripLinkRegistry(userId, result.tripId, data);
    }

    return result;
  };

  registered = true;
  return baseImportService;
}

export { baseImportService as importService };
export default baseImportService;
